import { Button } from "randmarcomps";
import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "randmarcomps";
import { ChevronDown, ChevronUp, SmilePlus } from "lucide-react";

const getEmojiElement = (emoji: string) => {
  const className = "w-full justify-self-center text-center text-base";
  switch (emoji) {
    case "&#9989;": return <div className={className}>&#9989;</div>;
    case "&#9996;": return <div className={className}>&#9996;</div>;
    case "&#11088;": return <div className={className}>&#11088;</div>;
    case "&#127774;": return <div className={className}>&#127774;</div>;
    case "&#128161;": return <div className={className}>&#128161;</div>;
    case "&#128170;": return <div className={className}>&#128170;</div>;
    case "&#129505;": return <div className={className}>&#129505;</div>;
    case "&#128338;": return <div className={className}>&#128338;</div>;
    case "&#10068;": return <div className={className}>&#10068;</div>;
    case "&#128681;": return <div className={className}>&#128681;</div>;
    case "&#127384;": return <div className={className}>&#127384;</div>;
    case "&#9940;": return <div className={className}>&#9940;</div>;
    default: return <div className={className}>&#129300;</div>;
  }
};

interface IProps {
  children: React.ReactNode;
  buttonText?: string;
  size?: "small" | "medium" | "large";
  variant?: "text" | "reseller" | "outlined" | "contained" | "manufacturer" | undefined;
  icon?: React.ReactNode;
  alignTop?: boolean;
  color?: string;
  backgroundColor?: string;
  emoji?: string;
}

const ButtonWithActions = ({ children, buttonText, size, icon, variant, alignTop, backgroundColor, color, emoji }: IProps) => {
  const randmarSize = size === "small" ? "sm" : size === "large" ? "lg" : "default";

  const muiVariant = variant || "contained";
  const randmarVariant = muiVariant === "outlined" ? "outline" : muiVariant === "text" ? "ghost" : "default";

  const customClasses = [
    size !== "small" ? "w-full" : "",
    backgroundColor
      ? `bg-[${backgroundColor}] hover:brightness-95`
      : muiVariant !== "outlined" && muiVariant !== "text"
        ? "bg-[#582c83] text-white hover:bg-[#582c83]/90"
        : "",
    color ? `text-[${color}]` : "",
  ].filter(Boolean).join(" ");

  return (
    <Popover>
      <PopoverTrigger asChild>
        {
          buttonText === "Add Reaction" ?
            <Button variant="ghost" size="icon">{emoji ? getEmojiElement(emoji) : <SmilePlus />}</Button>
            :
            <Button variant={randmarVariant} size={randmarSize} className={customClasses}>
              {
                buttonText &&
                <span className="mx-2">
                  {buttonText}
                </span>
              }
              {
                icon ||
                (alignTop ? <ChevronUp /> : <ChevronDown />)
              }
            </Button>
        }
      </PopoverTrigger>
      <PopoverContent
        side={alignTop ? "top" : "bottom"}
        align="end"
        className="border-2 border-[#582c83] shadow-md"
      >
        {children}
      </PopoverContent>
    </Popover>
  )
}

export default ButtonWithActions;
